export const sortCaseInsensitive = (a, b, priorities = []) => {
  const aLowerCase = a.toLowerCase();
  const bLowerCase = b.toLowerCase();

  if (priorities.length) {
    const prioritiesLowerCase = priorities.map((priority) => priority.toLowerCase());
    const priorityAIndex = prioritiesLowerCase.indexOf(aLowerCase);
    const priorityBIndex = prioritiesLowerCase.indexOf(bLowerCase);

    if (![priorityAIndex, priorityBIndex].includes(-1)) {
      return priorityAIndex < priorityBIndex ? -1 : 1;
    }

    if (prioritiesLowerCase.includes(aLowerCase)) {
      return -1;
    }
    if (prioritiesLowerCase.includes(bLowerCase) && !prioritiesLowerCase.includes(aLowerCase)) {
      return 1;
    }
  }

  if (aLowerCase < bLowerCase) {
    return -1;
  }
  if (aLowerCase > bLowerCase) {
    return 1;
  }
  return 0;
};
